// Configuration constants pour l'authentification patient
export const PATIENT_AUTH_CONFIG = {
  // Clés de stockage local
  STORAGE_KEYS: {
    PATIENT_TOKEN: 'patient_form_token',
    PATIENT_DATA: 'patient_form_data',
    PATIENT_SESSION: 'patient_session_data',
  },
  
  // Configuration des tokens
  TOKEN: {
    LENGTH: 32, // Longueur du token en caractères
    EXPIRY_HOURS: 48, // Durée de validité par défaut (48h)
    AUTO_EXTEND_THRESHOLD: 4, // Étendre automatiquement si moins de 4h restantes
    MAX_ACCESS_COUNT: 50, // Limite d'accès par token
  },
  
  // Configuration de l'auto-save
  AUTO_SAVE: {
    INTERVAL_MS: 30000, // 30 secondes
    DEBOUNCE_MS: 2000, // 2 secondes de debounce pour les changements
    MAX_RETRIES: 3, // Nombre max de tentatives de sauvegarde
  },
  
  // Configuration Apollo Client pour les patients
  APOLLO: {
    ROLE: 'patient_form',
    HEADER_KEY: 'x-hasura-patient-token',
    URI: 'https://iolmatch.hasura.app/v1/graphql',
    FETCH_POLICY: 'cache-and-network' as const,
  },
  
  // Validation des formulaires
  VALIDATION: {
    REQUIRED_BIOMETRIE_FIELDS: [
      'photicEffect',
      'glasses',
    ] as const,
    REQUIRED_HABITUDES_FIELDS: [
      'heureReveil',
      'heureCoucher',
    ] as const,
  },
  
  // Messages d'erreur
  ERROR_MESSAGES: {
    TOKEN_EXPIRED: 'Le lien a expiré. Veuillez demander un nouveau lien à votre chirurgien.',
    TOKEN_INVALID: 'Le lien est invalide. Veuillez vérifier l\'URL ou contacter votre chirurgien.',
    TOKEN_USED: 'Ce lien a déjà été utilisé. Veuillez demander un nouveau lien.',
    NETWORK_ERROR: 'Erreur de connexion. Vérifiez votre connexion internet et réessayez.',
    SAVE_ERROR: 'Erreur lors de la sauvegarde. Vos données ont été conservées localement.',
    VALIDATION_ERROR: 'Veuillez remplir tous les champs obligatoires avant de continuer.',
  },
  
  // Messages de succès
  SUCCESS_MESSAGES: {
    SAVE_SUCCESS: 'Données sauvegardées avec succès',
    FORM_COMPLETED: 'Formulaire complété avec succès',
    AUTO_SAVE: 'Sauvegarde automatique effectuée',
  },
} as const;

// Types dérivés des constantes
export type PatientStorageKey = typeof PATIENT_AUTH_CONFIG.STORAGE_KEYS[keyof typeof PATIENT_AUTH_CONFIG.STORAGE_KEYS];
export type BiometrieRequiredField = typeof PATIENT_AUTH_CONFIG.VALIDATION.REQUIRED_BIOMETRIE_FIELDS[number];
export type HabitudesRequiredField = typeof PATIENT_AUTH_CONFIG.VALIDATION.REQUIRED_HABITUDES_FIELDS[number];

// Configuration des endpoints (à adapter selon l'environnement)
export const PATIENT_ENDPOINTS = {
  HASURA_URL: 'https://iolmatch.hasura.app/v1/graphql',
  HASURA_WS_URL: 'wss://iolmatch.hasura.app/v1/graphql',
} as const;

// Configuration de sécurité
export const SECURITY_CONFIG = {
  // Headers de sécurité
  SECURITY_HEADERS: {
    'Content-Security-Policy': "default-src 'self'",
    'X-Content-Type-Options': 'nosniff',
    'X-Frame-Options': 'DENY',
  },
  
  // Validation des tokens
  TOKEN_VALIDATION: {
    MIN_LENGTH: 24,
    MAX_LENGTH: 64,
    ALLOWED_CHARS: /^[A-Za-z0-9_-]+$/,
  },
  
  // Rate limiting (côté client)
  RATE_LIMIT: {
    MAX_REQUESTS_PER_MINUTE: 30,
    BLOCK_DURATION_MS: 60000, // 1 minute
  },
} as const;

// Configuration de l'environnement
export const ENVIRONMENT = {
  isDevelopment: __DEV__,
  isProduction: !__DEV__,
  enableDebugLogs: __DEV__,
  enableAnalytics: !__DEV__,
} as const;